export interface Theme {
    name: string;
    properties: any;
}


/* greys
    almost black
black - #222222 -  #6B6B6B - #8E8E8E -999999-a6a6a6 CACACA -  -cfcfcf -  - dee2e6 - D1D1D1- e3e3e3 == E0E0E0 F0F0F0 white

        "--" : "" ,

amazon
background beige degrade: f4f1d6  ---- f4f1d6
text dark greenish: 183f39


*/

/*
 * C = color aka background-color
 * B = Border
 * F = Font aka color
 * */

export const light: Theme = {
    name: "light", 
    properties: { 

        "--cardB": "1.2px solid rgba(0, 0, 0, 0.125)",
        "--cardF": "black",
        "--card-headerC": "#F0F0F0",
        "--card-headerC-alt": "#e6e6e6",
        "--card-headerC-hover": "rgba(0, 0, 0, 0.1)",
        "--card-headerF": "black",
        "--tableB": "1px solid #dee2e6",
        "--helpC": "#6B6B6B",
        "--helpC-hover": "#8E8E8E",
        "--helpF": "rgba(0, 0, 0, 0.03)",
        "--button-background-primary": "#E0E0E0",
        "--button-background-primary-hover": "#D1D1D1",
        "--button-text-primary": "black",
        "--card-footerC": "rgba(0, 0, 0, 0.03)",
        "--card-footerF": "black",
        "--card-footerButtonF": "black",
        "--table-iconC": "#6B6B6B",
        "--table-iconC-hover": "black",
        "--btn-primary-tsC": "linear-gradient(to top, #007bff 0%,#0062cc 70%)",
        "--btn-primary-tsChover": "linear-gradient(to top, #4693e3  0%,#0069d9 70%)",
        "--topbar-background-color": "#222",
        "--topbar-border-color": "1px solid #999",
        "--topbar-background-color-hover": "black",
        "--topbar-font-color": "#999",
        "--sidebar-background-color": "#222",
        "--sidebar-font-color": "#999",
        "--header-location-notification": "#f91803",
        "--sidebar-border": "1px solid #dee2e6",
        "--goToPlanIcon": "black",
        "--cover-background-color": "#e6e6e6",
        "--switch-current": "black",
        "--cardB-alt": "1.2px solid rgba(0, 0, 0, 0.125)",

        "--headerbar-background-color1": "white",
        "--headerbar-background-color2": "#f91803",
        "--sidebar-background-color-hover1": "black",
        "--sidebar-background-color-hover2": "#f91803",
        "--button-font-color": "#c70212",

        "--bodyC": "white",
        "--cardC": "white",
        "--card-bodyC": "white",
        "--card-headC": "white",
        "--btn-primary-tsF": "white",
        "--btn-primary-tsB": "solid 1px white",
        "--btn-primary-tsBhover": "solid 1px white",
        "--btn-primary-tsFhover": "white",
        "--topbar-font-color-hover": "#f91803",
        "--sidebar-font-color-hover": "white",


/*
        "--bodyC": "#f4f1d6",
        "--cardC": "#f4f1d6",
        "--card-bodyC": "#f4f1d6",
        "--card-headC": "#f4f1d6",
        "--btn-primary-tsF": "#f4f1d6",
        "--btn-primary-tsB": "solid 1px #f4f1d6",
        "--btn-primary-tsBhover": "solid 1px #f4f1d6",
        "--btn-primary-tsFhover": "#f4f1d6",
        "--topbar-font-color-hover": "#f4f1d6",
        "--sidebar-font-color-hover": "#f4f1d6",
*/
        //#endregion
    }
};


export const dark: Theme = {
    name: "dark",
    properties: {

        "--bodyC": "#6B6B6B",
        "--cardB": "1.2px solid #222222",
        "--cardC": "#CACACA",
        "--cardF": "black",
        "--card-headerC": "#8E8E8E",
        "--card-headerC-alt": "#8E8E8E",
        "--card-headerC-hover": "#a6a6a6",
        "--card-headerF": "white",
        "--tableB": "1px solid #222222",
        "--card-bodyC": "#F0F0F0",
        "--card-headC": "#E0E0E0",
        "--helpC": "white",
        "--helpC-hover": "#E0E0E0",
        "--helpF": "#6B6B6B",
        "--button-background-primary": "#E0E0E0",
        "--button-background-primary-hover": "#F0F0F0",
        "--button-text-primary": "bootstrap overrides me with #007bff",
        "--card-footerC": "#8E8E8E",
        "--card-footerF": "white",
        "--card-footerButtonF": "black",
        "--table-iconC": "#6B6B6B",
        "--table-iconC-hover": "black",
        "--btn-primary-tsC": "linear-gradient(to top, #007bff 0%,#0062cc 70%)",
        "--btn-primary-tsF": "white",
        "--btn-primary-tsB": "solid 1px white",
        "--btn-primary-tsBhover": "solid 1px white",
        "--btn-primary-tsChover": "linear-gradient(to top, #4693e3  0%,#0069d9 70%)",
        "--btn-primary-tsFhover": "white",
        "--topbar-background-color": "#222",
        "--topbar-border-color": "1px solid #999",
        "--topbar-background-color-hover": "black",
        "--topbar-font-color": "#999",
        "--topbar-font-color-hover": "white",
        "--sidebar-background-color": "#222",
        "--sidebar-background-color-hover": "black",
        "--sidebar-font-color": "#999",
        "--sidebar-font-color-hover": "white",
        "--header-location-notification": "#f91803",
        "--sidebar-border": "1px solid #dee2e6",
        "--goToPlanIcon": "white",
        "--cover-background-color": "#e6e6e6",
        "--switch-current": "black",
        "--cardB-alt": "1.2px solid #222222",

        "--headerbar-background-color1": "black",
        "--headerbar-background-color2": "#f91803",
        "--sidebar-background-color-hover1": "black",
        "--sidebar-background-color-hover2": "#f91803",
        "--button-font-color": "#c70212",
        //#endregion
    }
};


//#endregion

/*
 * For now the difference between the themes are only light and dark
If more than those themes are to be active, ther eis work to be done in the theme.ts




*/
